import React from "react";
import { Bell, Clock } from "lucide-react";
import { cn } from "../../lib/utils";
import {
  getNotifTitle,
  getNotifBody,
  getNotifTime,
} from "../../utils/NotificationHelpers";

const NotificationToast = ({ notification }) => {
  return (
    <div className="flex flex-col gap-2 p-1">
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Bell className="h-4 w-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm leading-snug line-clamp-3 font-medium text-foreground">
            {notification.standard_name && (
              <span className="text-primary font-semibold">
                {notification.standard_name}
              </span>
            )}
            {notification.standard_name && notification.module_name && (
              <span className="mx-1 text-muted-foreground/50">•</span>
            )}
            <span className="text-[#4A1E6A] font-semibold">
              {getNotifTitle(notification)}
            </span>
            <span className="text-muted-foreground font-normal ms-1">
              : {getNotifBody(notification)}
            </span>
          </p>
          <div className="flex items-center gap-1 pt-0.5 text-[10px] text-muted-foreground/70">
            <Clock className="h-2.5 w-2.5" />
            <span>{getNotifTime(notification)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationToast;
